import Alert from 'antd/lib/alert';
import Form from 'antd/lib/form';
import Space from 'antd/lib/space';
import Switch from 'antd/lib/switch';
import Typography from 'antd/lib/typography';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';

const { Text } = Typography;

function SmartSelectorSwitch({
  name,
  title,
  description,
  errorMessage,
  errorDescription,
  disabled = false,
}) {
  const importantNote = disabled && (
    <div style={{ marginTop: '6px' }}>
      <Alert
        message={errorMessage}
        description={errorDescription}
        type='error'
        showIcon
        icon={<InfoCircleOutlined />}
        closable={false}
      />
    </div>
  );

  return (
    <>
      <Space
        align='center'
        style={{ justifyContent: 'space-between', width: '100%' }}
        size={24}
      >
        <Space direction='vertical' size={0}>
          <Text strong>{title}</Text>
          <Text>{description}</Text>
        </Space>

        <Form.Item name={name} valuePropName='checked'>
          <Switch disabled={disabled} />
        </Form.Item>
      </Space>
      {importantNote}
    </>
  );
}

export default SmartSelectorSwitch;
